import IconTextComponent from "../components/can/Can"
import styles from "./SecondScreen.module.css"
import price from "../icons/wired-outline-2913-price-down-hover-pinch (1).json"
import ScrollTimeline from "../components/Timeline/Timeline"
import Button from "../components/button/Button"
import result1 from "../images/לידים רותחים.png"
import result2 from "../images/עלויות נמוכות.png"
import result3 from "../images/מכירות והחזרים.png"
import { useEffect, useRef } from "react"
import ScrollReveal from "scrollreveal"

const SecondScreen = () => {
    const imageRef1 = useRef(null)
    const imageRef2 = useRef(null)
    const imageRef3 = useRef(null)

    useEffect(() => {
        const sr = ScrollReveal({
            origin: 'top',
            distance: '50px',
            duration: 800,
            easing: 'ease-out',
            opacity: 0,
            reset: false
        })

        sr.reveal(imageRef1.current, { delay: 0 })
        sr.reveal(imageRef2.current, { delay: 200 })
        sr.reveal(imageRef3.current, { delay: 400 })
    }, [])

    return <>
         {/* <div className={styles.title}>
           לפני שנדבר.. <span className={styles.highlight}>זמן תוצאות</span>
        </div> */}
         
        {/* גלריית תמונות */}
        {/* <div className={styles.imageGallery}>
            <div className={styles.imageWrapper} ref={imageRef1}>
                <img src={result1} alt="תוצאה 1" className={styles.galleryImage} />
                <div className={styles.mobileButtonWrapper}>
               
                </div>
            </div>
            <div className={styles.imageWrapper} ref={imageRef2}>
                <img src={result2} alt="תוצאה 2" className={styles.galleryImage} />
                <div className={styles.mobileButtonWrapper}>
             
                </div>
            </div>
            <div className={styles.imageWrapper} ref={imageRef3}>
                <img src={result3} alt="תוצאה 3" className={styles.galleryImage} />
                <div className={styles.mobileButtonWrapper}>
              
                </div>
            </div>
        </div> */}
      {/* <Button text="הילה בואי נדבר!"/> */}
 
        <div className={styles.title}>
            ועכשיו נדבר<span className={styles.highlight}> תכל'ס</span>
        </div>
        <div className={styles.description}>
            אנחנו נותנים שירות מעולה. לקוחות שמגיעים אלינו - מרוצים, ממליצים, חוזרים.
            אבל איפשהו בין מה שהעסק באמת נותן, לבין איך שהוא נראה ברשת…
            משהו מתפספס.
        </div>
        <div className={styles.title}>תגידו אם זה נשמע לכם מוכר..</div>
        <div className={styles.description}>
            ✦ ליצור תוכן לפעמים מרגיש כמו עוד משימה לסמן עליה וי.<br/>
            ✦ יש רגעים שבהם אנחנו מסתכלים על מה שעלה ואומרים לעצמנו: "זה לא באמת משקף את מי שאנחנו."<br/>
            ✦ אנחנו יודעים שיש בעסק הרבה יותר ערך ממה שרואים כלפי חוץ - וזה מתסכל.<br/>
            ✦ ובמקביל, עסקים פחות מנוסים מאיתנו מתפוצצים ברשת… ואנחנו חושבים: "מה הם עושים שאנחנו לא?"
        </div>
        <div className={styles.title}>ובזמן הזה</div>
        <div className={styles.row}>
            <IconTextComponent text="לידים לא נכנסים באופן יציב" icon={price}/>
            <IconTextComponent text='חלק מהפניות נפתחות ב-"כמה זה עולה?"' icon={price}/>
            <IconTextComponent text="ויש לא מעט מיקוח על מחיר שלא אמור לקרות בכלל" icon={price}/>
        </div>
        <div className={styles.title}>
            אבל הנה החדשות <span className={styles.highlight}>הטובות</span>
        </div>
        <div className={styles.description}>
            לא צריך להיות מומחי שיווק כדי להביא לקוחות. לא צריך להבין אלגוריתמים, פסיכולוגיית צבעים, או "לשחק דמות" מול מצלמה.
        </div>
        <div className={styles.description}>
            <strong>מה שכן צריך - זה לתרגם את מי שאנחנו באמת לנוכחות דיגיטלית שמחממת לידים עוד לפני שיחה.</strong>
        </div>
        <div className={styles.title}>
            דמיינו את העסק בעוד <span className={styles.highlight}>90 יום</span>
        </div>
        <ScrollTimeline/>
        <div className={styles.description}>
            זה מה שקורה כשהשיווק מפסיק להיות "עוד משימה" ומתחיל להיות מערכת שמייצרת אמון, לידים - ומכירות.
        </div>
        <div className={styles.title}>
            ואנחנו כאן <span className={styles.highlight}>כדי להגיע לשם</span>
        </div>

        <Button text="הילה בואי נדבר!"/>
      <div className={styles.title}>
 ולמה שתקשיבו לי בכלל?
        </div>
          <div className={styles.description}>
לפני שממשיכים… תנו לי כמה שניות לספר לכם איך הגעתי להפוך מצלמה אחת למכונת מכירות.

        </div>
    </>
}

export default SecondScreen